if (!window.KLWrapSelector) {
  window.KLWrapSelector = {
    boot: function () {
      document.querySelectorAll('[data-kl-wrap-selector]').forEach(function (root) {
        window.KLWrapSelector.init(root);
      });
    },

    init: function (root) {
      if (!root || root.dataset.klWrapReady === 'true') return;
      root.dataset.klWrapReady = 'true';

      function optionInput(option) {
        return option.querySelector('input');
      }

      function setSelected(option) {
        var group = option.getAttribute('data-group');
        root.querySelectorAll('[data-kl-wrap-option]').forEach(function (el) {
          if (el.getAttribute('data-group') === group) {
            el.classList.remove('is-selected');
          }
        });
        option.classList.add('is-selected');
        var input = optionInput(option);
        if (input) input.checked = true;
        var groupEl = option.closest('[data-kl-wrap-group]');
        var selectedLabel = groupEl && groupEl.querySelector('[data-kl-wrap-selected]');
        if (selectedLabel) selectedLabel.textContent = option.getAttribute('data-label') || '';
      }

      function closeStage(stage) {
        stage.classList.remove('is-open');
        stage.setAttribute('aria-hidden', 'true');
        stage.inert = true;
      }

      function closeAll() {
        root.querySelectorAll('[data-kl-wrap-stage].is-open').forEach(closeStage);
        root.querySelectorAll('[data-kl-wrap-option].is-active').forEach(function (el) {
          el.classList.remove('is-active');
        });
      }

      function showOption(option) {
        if (!root.isConnected) return;
        var src = option.getAttribute('data-large-src');
        if (!src) return;
        var groupEl = option.closest('[data-kl-wrap-group]');
        var stage = groupEl && groupEl.querySelector('[data-kl-wrap-stage]');
        if (!stage) return;

        root.querySelectorAll('[data-kl-wrap-stage].is-open').forEach(function (other) {
          if (other !== stage) closeStage(other);
        });
        root.querySelectorAll('[data-kl-wrap-option].is-active').forEach(function (el) {
          if (el !== option) el.classList.remove('is-active');
        });
        option.classList.add('is-active');

        var img = stage.querySelector('img');
        var caption = stage.querySelector('[data-kl-wrap-label]');
        var label = option.getAttribute('data-label') || '';
        if (caption) caption.textContent = label;

        if (img) {
          img.alt = label;
          var token = (img._klToken || 0) + 1;
          img._klToken = token;

          var reveal = function () {
            if (img._klToken !== token) return;
            img.classList.add('is-ready');
          };

          if (img.getAttribute('src') !== src) {
            img.classList.remove('is-ready');
            window.setTimeout(function () {
              if (img._klToken !== token) return;
              img.onload = reveal;
              img.src = src;
              if (img.complete && img.naturalWidth > 0) reveal();
            }, img.getAttribute('src') ? 120 : 0);
          } else if (!img.classList.contains('is-ready')) {
            reveal();
          }
        }

        stage.classList.add('is-open');
        stage.setAttribute('aria-hidden', 'false');
        stage.inert = false;
      }

      root.querySelectorAll('[data-kl-wrap-option]').forEach(function (option) {
        var input = optionInput(option);
        if (input && input.checked) setSelected(option);

        option.addEventListener('click', function () {
          setSelected(option);
          showOption(option);
        });

        if (input) {
          input.addEventListener('change', function () {
            if (!input.checked) return;
            setSelected(option);
            showOption(option);
          });
        }
      });

      var seenGroups = {};
      root.querySelectorAll('[data-kl-wrap-option]').forEach(function (option) {
        var group = option.getAttribute('data-group');
        if (seenGroups[group]) return;
        var groupOptions = root.querySelectorAll('[data-kl-wrap-option][data-group="' + group + '"]');
        var hasChecked = false;
        groupOptions.forEach(function (el) {
          var input = optionInput(el);
          if (input && input.checked) hasChecked = true;
        });
        if (!hasChecked && groupOptions[0]) setSelected(groupOptions[0]);
        seenGroups[group] = true;
      });

      root.querySelectorAll('[data-kl-wrap-close]').forEach(function (closeBtn) {
        closeBtn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          closeAll();
        });
      });

      document.addEventListener('click', function (event) {
        if (!root.isConnected) return;
        if (!root.querySelector('[data-kl-wrap-stage].is-open')) return;
        if (root.contains(event.target)) return;
        closeAll();
      });

      document.addEventListener('keydown', function (event) {
        if (!root.isConnected) return;
        if (event.key !== 'Escape') return;
        if (!root.querySelector('[data-kl-wrap-stage].is-open')) return;
        closeAll();
      });
    }
  };

  document.addEventListener('shopify:section:load', function () {
    window.KLWrapSelector.boot();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.KLWrapSelector.boot);
  } else {
    window.KLWrapSelector.boot();
  }
}
